export default __webpack_public_path__ + "static/media/recibo-esferas.6ea77c9c.png";